<video #videoPlayer id="videoPlayer" width="100%" height="100%">
